import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import InfoCards from '../components/InfoCards';
import MigrationFlow from '../components/Migrations';
import UserInfoModal from "../components/UserInfoModal";
import videocover from '../assets/videocover.png';
import ComparisonHub from '../components/ComparisonHub';

function LandingPage() {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div className="min-h-screen bg-bg text-text-primary">
      <Navbar />

      <UserInfoModal isOpen={openModal} onClose={() => setOpenModal(false)} />

      {/* Promotion Bar */}
      <div className="text-center py-3 px-4 border-b border-border bg-bg-soft animate-fade-in-up">
        <p className="text-sm md:text-base font-medium text-text-primary">
          Hi! You can migrate <span className="font-bold">10,000</span> vectors for free!
          <span className="hidden md:inline"> Grab your chance now.</span>
        </p>
      </div>

      {/* Hero Section */}
      <section className="relative py-40 px-6 overflow-hidden text-center bg-white">
        <div className="relative z-10 max-w-4xl mx-auto animate-fade-in-up text-center">

          <h1 className="text-4xl md:text-5xl font-extrabold mb-6 text-text-primary">
            Vector DB Migration Made Easy
          </h1>

          {/* <h2 className="text-2xl md:text-3xl font-semibold mt-4 text-text-primary">
            Effortless Migration Between Pinecone, Qdrant, Chroma, Weaviate, Milvus & MongoDB.
          </h2> */}

          {/* <p className="mt-6 text-lg md:text-xl font-medium text-text-secondary">
            Seamlessly migrate vector embeddings between leading vector databases.
            Built for AI developers, ML engineers, and teams working on semantic search,
            RAG pipelines, and AI-powered applications.
          </p> */}

             <p className="mt-6 text-lg md:text-xl font-medium text-text-secondary">
              Seamlessly migrate vector embeddings between leading vector databases.
            </p>

          <div className="flex items-center justify-center gap-4 mt-12">
            <button
              onClick={() => setOpenModal(true)}
              aria-label="Start vector database migration"
              className="px-6 py-3 rounded-md text-lg font-bold shadow-md transition bg-primary text-white hover:bg-primary-soft"
            >
              Get Started
            </button>

            <a
              href="https://calendly.com/syed-agileforce/discovery-call"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Request vector database migration demo"
              className="px-6 py-3 rounded-md text-lg font-bold shadow-md transition border-2 border-primary text-primary bg-transparent hover:bg-primary hover:text-white"
            >
              Request Demo
            </a>
          </div>

          <p className="mt-6 text-sm text-text-secondary">
            Start your vector database migration today with a secure and scalable solution.
          </p>
        </div>
      </section>

      {/* Video Section */}
      <section className="w-full flex justify-center items-center py-40 px-6 bg-bg-soft">
        <div className="w-full max-w-4xl px-4">

          <p className="text-center mb-6 text-text-secondary">
            Watch how Vector Migration simplifies moving vector data between databases.
          </p>

          <div className="relative aspect-video rounded-2xl overflow-hidden shadow-2xl border border-border">
            <video
              className="w-full h-full object-cover"
              controls
              poster={videocover}
              src="https://agileforce-videos.s3.us-east-2.amazonaws.com/vector_migration.mp4"
              aria-label="Vector database migration demo video"
            />
          </div>
        </div>
      </section>

      <MigrationFlow />
      <InfoCards />
      <ComparisonHub />
      <Footer />
    </div>
  );
}

export default LandingPage;